import React from "react";
import { connect } from "react-redux";
import DataGrid, { Column, Paging, RemoteOperations } from "devextreme-react/ui/data-grid";
import { Button } from "devextreme-react";
import { sendAgendamiento, lastStep } from "../../actions";
import Moment from "moment";
import LoadingGif from "../../../../../../../images/animacion2[18].gif";
import validaciones from "../../../../../../../helpers/validaciones";
import { formatDateForFilter } from "../../../../../../../helpers/dateFormat";
class ConfirmacionSolicitud extends React.Component {
  handleBack = () => {
    this.props.dispatch(lastStep());
  }

    enviarSolicitud = () => {
      this.props.onSend();
      const _updated = {
        isWorkersUpdate: this.props.isWorkersUpdate,
        isPoolsUpdate: this.props.isPoolsUpdate,
        isExamsUpdate: this.props.isExamsUpdate,
        isRequestHeaderUpdate: this.props.isRequestHeaderUpdate,
      };
      const filters = {
        from: formatDateForFilter(Moment().subtract(1, "year")),
        to: formatDateForFilter(Moment()),
        companyRut: this.props.companyId,
        PetitionerRut: this.props.userData.RUT,
        StatusId: this.props.selectedTipoSolicitud.value.value,
      };
      this.props.dispatch(sendAgendamiento(this.props.dataSolicitudAgendaSel, this.props.companyId, this.props.userData.RUT, 1, _updated, null, filters, this.props.centroSeleccionado));
    }

    render() {
      const {
        solicitante,
        centroCostos,
        tipoEvaluacion,
        cargo,
        otroCargo,
        baterias,
        examenesAdicionales,
        examenesPsicologicos,
        fechaReferencia,
        fechaReferenciaEnd,
        listaEmpleados,
        nombreAprobador        
      } = this.props.dataSolicitudAgendaSel;
      var centro = [...baterias, ...examenesAdicionales, ...examenesPsicologicos].find(e => e.AchsOffices && e.AchsOffices.find(ee => ee.Id === this.props.centroSeleccionado));
      centro = centro && centro.AchsOffices.find(e => e.Id === this.props.centroSeleccionado)
      const _tipoEvaluacion = this.props.listaTipoExamenes.find((e) => e.Id === tipoEvaluacion);
      const _cargo = this.props.listaCargos.find((e) => e.Id === cargo);
      const _listaEmpleados = () => {
        const _data = listaEmpleados.map((e) => {
          const _rut = e.rutEmpleado && e.rutEmpleado.trim() ? e.rutEmpleado.trim() : "";
          if (e.edadEmpleado === 0) e.edadEmpleado = null;

          const tipo = this.props.tipoDocumentos.find((tipo) => tipo.Id === e.tipoDocumento);

          e.tipoDocumentoDescripcion = tipo.Tipo;

          return _rut && e.nombreEmpleado ? e :
            {
              nombreEmpleado: "Sin Nombre",
              rutEmpleado: "",
              edadEmpleado: null,
              celularEmpleado: "",
              emailEmpleado: "",
              tipoDocumento: "",
            };
        });
        return _data;
      };
      let countSN = 0; let countCN = 0;
      for (let i = 0; i < listaEmpleados.length; i++) {
        if (listaEmpleados[i].nombreEmpleado && listaEmpleados[i].rutEmpleado) { countCN++; } else { countSN++; } 
      }

      return (

        <React.Fragment>
          <div className="confirmacionSolicitud" style={{ maxWidth: 700 }}>
            <div className="row">
              <div className="col-12">
                <h4 className="confirmacion-subtitle">Datos del aprobador</h4>
              </div>
              <div className="col-4">
                <h3><p>Aprobador</p></h3>
                <span>
                  {solicitante || ""} {nombreAprobador || ""}
                </span>
              </div>
              <div className="col-6">
                <h3><p>Centro de costos</p></h3>
                <span>{centroCostos}</span>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <h4 className="confirmacion-subtitle">Solicitud de exámenes</h4>
              </div>
              <div className="col-12 marginbottom">
                <h3><p>Centro de atención</p></h3>
                <span>{centro && centro.Description ? centro.Description :""}</span>
              </div>
              <div className="col-4 marginbottom">
                <h3><p>Tipo de evaluación a realizar</p></h3>
                <span>{_tipoEvaluacion && _tipoEvaluacion.Description ? _tipoEvaluacion.Description : ""}</span>
              </div>
              <div className="col-4 marginbottom">
                <h3><p>Cargo</p></h3>
                <span>{_cargo && _cargo.Description && _cargo.Description !== "OTRO" ? _cargo.Description : ""}{otroCargo && _cargo.Description === "OTRO" ? otroCargo : ""}</span>
              </div>
              
              <div className="col-4 marginbottom">
                <h3><p>Posibilidad de fecha</p></h3>
                <span>{fechaReferencia ? Moment(fechaReferencia).format("DD/MM/YYYY") : ""}{fechaReferenciaEnd ? ` - ${Moment(fechaReferenciaEnd).format("DD/MM/YYYY")}` : ""}</span>
              </div>
              <div className="col-4 marginbottom">
                <h3><p>Batería de exámenes</p></h3>
                {baterias.map((e) => {
                  return e.Description ? <span key={e.Id} style={{ width: "100%", float: "left" }}>{e.Description}</span> : null;
                })}
              </div>
              <div className="col-4 marginbottom">
                <h3><p>Exámenes adicionales</p></h3>
                <div className="row">
                  <div className="col-12">
                    {examenesAdicionales.map((e, i) => {
                      return e.Description ? <span key={e.Id} style={{ width: "100%", float: "left" }}>{e.Description}</span> : null;
                    })}
                  </div>
                </div>
              </div>
              <div className="col-4 marginbottom">
                <h3><p>Evaluaciones psicológicas</p></h3>
                <div className="row">
                  <div className="col-12">
                    {examenesPsicologicos.map((e) => {
                      return e.Description ? <span key={e.Id} style={{ width: "100%", float: "left" }}>{e.Description}</span> : null;
                    })}
                  </div>
                </div>
              </div>
              
            </div>

            <div className="row">
              <div className="col-12">
                <h4 className="confirmacion-subtitle">Trabajadores</h4>
                <div className="row zero ">
                  <span>Ingresados: {`${countCN} - `} Sin nombre: {countSN}</span>
                </div>
              </div>
              <div className="col-12 lista-trabajadores-confirmacion">
                <DataGrid
                  dataSource={_listaEmpleados()}
                  showBorders={false}
                  showColumnLines={false}
                  showRowLines={false}
                  className="custom-table"
                  noDataText=""
                  rowAlternationEnabled
                  hoverStateEnabled={false}
                  activeStateEnabled={false}
                  focusStateEnabled={false}
                  loadPanel={{
                    enabled: true,
                    showPane: true,
                    showIndicator: true,
                    indicatorSrc: LoadingGif,
                    text: "Cargando...",
                  }}
                  onContentReady={(e) => {
                    if (e.component.totalCount() === 0) {
                      const config = {};
                      config.addClass = "table-margin";
                      const noDataSpan = e.component.element().querySelector(".dx-datagrid-nodata");
                      const element = validaciones.noDataDOMElement(config, "Sin siniestros");
                      noDataSpan.appendChild(element);
                    }
                  }}
                  pager={{
                    showInfo: true,
                    visible: true,
                    infoText: (page, total, items) => `Página ${page} de ${total} (${items} resultados)`,
                  }}
                >
                  <Column dataField="tipoDocumentoDescripcion" caption="Tipo documento"/>
                  <Column dataField="rutEmpleado" caption="Nro documento" />
                  <Column dataField="nombreEmpleado" caption="Nombre"/>
                  <Column dataField="celularEmpleado" caption="Celular"/>
                  <Column dataField="emailEmpleado" caption="Email"/>

                  <Paging
                    pageSize={20}
                  />

                  <RemoteOperations
                    paging
                    filtering
                    summary={false}
                    groupPaging={false}
                    grouping={false}
                    sorting={false}
                  />
                </DataGrid>
              </div>
            </div>
            <div className="row buttons-next-prev">
              <div className="col-6">
                <Button text="Volver" className="back-button" onClick={this.handleBack} />
              </div>
              <div className="col-6">
                <Button text="Enviar" type="success" className="next-button" onClick={this.enviarSolicitud} disabled={!!this.props.isLoading} />
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    }
}
const mapStateToProps = (state) => ({
  selectedTipoSolicitud: state.solicitudesAgendaSel.selectedTipoSolicitud,
  userData: state.global.userData,
  jsonData: state.solicitudesAgendaSel.jsonData,
  isLoading: state.solicitudesAgendaSel.isLoading,
  dataSolicitudAgendaSel: state.solicitudesAgendaSel.dataSolicitudAgendaSel,
  companyId: state.global.companyId,
  listaCargos: state.solicitudesAgendaSel.listaCargos,
  listaTipoExamenes: state.solicitudesAgendaSel.listaTipoExamenes,
  isPoolsUpdate: state.solicitudesAgendaSel.isPoolsUpdate,
  isExamsUpdate: state.solicitudesAgendaSel.isExamsUpdate,
  isWorkersUpdate: state.solicitudesAgendaSel.isWorkersUpdate,
  isRequestHeaderUpdate: state.solicitudesAgendaSel.isRequestHeaderUpdate,
  tipoDocumentos: state.solicitudesAgendaSel.tipoDocumentos,
  centroSeleccionado: state.solicitudesAgendaSel.centroSeleccionado
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmacionSolicitud);
